import { render, staticRenderFns } from "./formdialog.vue?vue&type=template&id=2deb80fa&scoped=true&"
import script from "./formdialog.vue?vue&type=script&lang=js&"
export * from "./formdialog.vue?vue&type=script&lang=js&"
import style0 from "./formdialog.vue?vue&type=style&index=0&id=2deb80fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deb80fa",
  null
  
)

export default component.exports